<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <div
        slot="content-right"
        class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
      >
        <h3 class="title upps-nofound">
          <i class="fa fa-warning"></i> Upps! Page no found.
        </h3>
        <p class="description">Sorry, the page no found.</p>
        <h2 class="number-nofound">
          <strong>404</strong>
        </h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404',
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style>
.upps-nofound,
.description {
  text-align: center !important;
}
.number-nofound {
  font-size: 50px !important;
  text-align: center !important;
}
</style>
